import React from "react";
import PropTypes, { number } from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@material-ui/core/Box';
import Collapse from "@material-ui/core/Collapse";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { MoreVert } from "@material-ui/icons";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Show from "./Show";
import Edit from "./Edit";
import PartialSaleStatusToggle from "./PartialSaleStatusToggle";
import { replace, startCase, toLower } from "lodash";
import numeral from "numeral";
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

const REMOVE_PARTIAL_SALE_LISTING = gql`
  mutation RemovePartialSaleListing($id: ID!, $userRole: String!) {
    removePartialSaleListing(id: $id, userRole: $userRole) {
      id
    }
  }
`;



const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

const PartialSaleListing = (props) => {
  const [partialSale, setPartialSale] = React.useState(props.partialSale);
  const [open, setOpen] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [removeDialogOpen, setRemoveDialogOpen] = React.useState(false);
  const classes = useRowStyles();
  const numberOfInterests = partialSale.partial_sale_listing_users.length;
  const { company, user, showMetricsColumns = true } = props; // showMetricsColumns defaults to true for backward compatibility
  const isOwner = partialSale.is_owner !== false; // Default to true for backward compatibility
  const isClosed = partialSale.sale_status === 'closed';
  const canRemove = isOwner || (!isOwner && isClosed); // Owner can always remove, buyer only if closed

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleEdit = () => {
    setEdit(!edit);
    handleClose();
  };

  const handleRemoveClick = () => {
    setRemoveDialogOpen(true);
    handleClose();
  };

  const handleRemoveCancel = () => {
    setRemoveDialogOpen(false);
  };

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {isOwner ? (
            <PartialSaleStatusToggle partialSale={partialSale} setPartialSale={setPartialSale} />
          ) : (
            <span style={{ 
              padding: '4px 8px', 
              borderRadius: '4px', 
              fontSize: '12px',
              backgroundColor: isClosed ? '#ffebee' : '#e8f5e9',
              color: isClosed ? '#c62828' : '#2e7d32'
            }}>
              {isClosed ? 'Closed' : 'Open'}
            </span>
          )}
        </TableCell>
        <TableCell>
        {partialSale.listed_at ? new Date(partialSale.listed_at).toLocaleDateString() : (partialSale.created_at ? new Date(partialSale.created_at).toLocaleDateString() : '-')}
        </TableCell>
        <TableCell component="th" scope="row">
          {partialSale.segment_details}
        </TableCell>
        {showMetricsColumns && (
          <TableCell align="right">
            {isOwner ? partialSale.views_count : '-'}
          </TableCell>
        )}
        {showMetricsColumns && (
          <TableCell align="right">
            {isOwner ? numberOfInterests : '-'}
          </TableCell>
        )}
        <TableCell align="right">
          {((isOwner && (edit || open)) || (!isOwner && open && canRemove)) && <React.Fragment>
            <IconButton
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVert />
            </IconButton>

            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {isOwner && (
                edit ? <MenuItem onClick={toggleEdit}>Stop Editing</MenuItem> : <MenuItem onClick={toggleEdit}>Edit</MenuItem>
              )}
              {canRemove && (
                <MenuItem onClick={handleRemoveClick} style={{ color: '#d32f2f' }}>Remove</MenuItem>
              )}
            </Menu>
          </React.Fragment>}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={showMetricsColumns ? 6 : 4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              {edit && isOwner ? (
                <Edit partialSale={partialSale} setPartialSale={setPartialSale} company={company} />
              ) : (
                <Show partialSale={partialSale} company={company} />
              )}
              
              {/* Show seller info for buyers */}
              {!isOwner && partialSale.user && (
                <React.Fragment>
                  <Typography variant="h6" gutterBottom component="div">
                    Owner
                  </Typography>

                  <Table size="small" aria-label="seller-info">
                    <TableHead>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          <div>
                            {partialSale.user.fb_user_name ? (
                              <a style={{ cursor: 'pointer' }} onClick={() => { document.x.a = partialSale.user.fb_user_name; }}>
                                {partialSale.user.user_name || partialSale.user.name || 'Owner'}
                              </a>
                            ) : (
                              <a style={{ cursor: 'pointer' }} onClick={() => { document.x.a = partialSale.user.user_name; }}>
                                {partialSale.user.user_name || partialSale.user.name || 'Owner'}
                              </a>
                            )}
                            {/* Seller's Transition Goals */}
                            {partialSale.user.transition_goal_names && partialSale.user.transition_goal_names.length > 0 && (
                              <div style={{ marginTop: '8px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                {partialSale.user.transition_goal_names.map((goal, index) => (
                                  <span
                                    key={index}
                                    style={{
                                      display: 'inline-block',
                                      padding: '2px 8px',
                                      fontSize: '0.75rem',
                                      borderRadius: '12px',
                                      backgroundColor: '#e3f2fd',
                                      color: '#1976d2',
                                      border: '1px solid #1976d2'
                                    }}
                                  >
                                    {goal}
                                  </span>
                                ))}
                              </div>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="right">
                          {(() => {
                            // Find current user's listing user record to get friendly_name for messaging
                            if (!user || !user.id) return null;
                            
                            const currentUserListingUser = partialSale.partial_sale_listing_users.find(
                              lu => lu.user_id === user.id
                            );
                            
                            if (currentUserListingUser && currentUserListingUser.friendly_name) {
                              return (
                                <form
                                  action="/messages/create_chat_from_partial_sale_user"
                                  method="post"
                                >
                                  <input 
                                    type="hidden" 
                                    name="friendly_id" 
                                    value={currentUserListingUser.friendly_name} 
                                  />
                                  <input type="hidden" name="authenticity_token" value={ReactOnRails.authenticityToken()} />
                                  <button
                                    className="chat-icon ml-auto btn-link"
                                    type="submit"
                                  >
                                    <i className="fas fa-envelope"></i>
                                  </button>
                                </form>
                              );
                            }
                            return null;
                          })()}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </React.Fragment>
              )}
              
              {isOwner && numberOfInterests > 0 && (
                <React.Fragment>
                  <Typography variant="h6" gutterBottom component="div">
                    Interests
                  </Typography>

                  <Table size="small" aria-label="purchases">
                    <TableHead>
                    </TableHead>
                    <TableBody>
                      {partialSale.partial_sale_listing_users.map((listingUser) => (
                        <React.Fragment>
                          <TableRow key={listingUser.friendly_name}>
                            <TableCell component="th" scope="row">
                              {listingUser.buyer.fb_user_name ? (
                                <a style={{ cursor: 'pointer' }} onClick={() => { document.x.a = listingUser.buyer.fb_user_name; }}>
                                  {listingUser.buyer.user_name}
                                </a>
                              ) : (
                                <a style={{ cursor: 'pointer' }} onClick={() => { document.x.a = listingUser.buyer.user_name; }}>
                                  {listingUser.buyer.user_name}
                                </a>
                              )}
                            </TableCell>
                            <TableCell>{listingUser.buyer.city}, {listingUser.buyer.province}</TableCell>
                            <TableCell align="right">{numeral(listingUser.buyer.assets_under_management).format('$0,0')} AUM</TableCell>
                            <TableCell align="right">{startCase(toLower(replace(listingUser.status, /_/g, ' ')))}</TableCell>

                            <TableCell align="right">
                              <form
                                action="/messages/create_chat_from_partial_sale_user"
                                method="post"
                              >
                                <input type="hidden" name="friendly_id" value={listingUser.friendly_name} />
                                <input type="hidden" name="authenticity_token" value={ReactOnRails.authenticityToken()} />
                                <button
                                  class="chat-icon ml-auto btn-link"
                                  type="submit">
                                    {listingUser.status !== 'expressed_interest' ? (
                                      <i class="fas fa-envelope"></i>
                                    ) : (
                                      "Approve"
                                    )}
                                </button>
                              </form>
                            </TableCell>
                          </TableRow>
                          {listingUser.status === 'expressed_interest' && (
                            <TableRow style={{border: '0'}}>
                              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                <h4>Request Message</h4>
                                {listingUser.request_message}
                              </TableCell>
                            </TableRow>
                          )}
                        </React.Fragment>
                      ))}
                    </TableBody>
                  </Table>
                </React.Fragment>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      {/* Remove Confirmation Dialog */}
      <Mutation
        mutation={REMOVE_PARTIAL_SALE_LISTING}
        variables={{ id: partialSale.id, userRole: isOwner ? 'seller' : 'buyer' }}
        onCompleted={() => {
          window.location.reload();
        }}
        onError={(error) => {
          console.error('Error removing listing:', error);
          alert('Failed to remove listing. Please try again.');
          setRemoveDialogOpen(false);
        }}
      >
        {(removeListing, { loading }) => (
          <Dialog
            open={removeDialogOpen}
            onClose={handleRemoveCancel}
            aria-labelledby="remove-dialog-title"
          >
            <DialogTitle id="remove-dialog-title">Remove Listing</DialogTitle>
            <DialogContent>
              <Typography>
                {isOwner ? (
                  'Removing this listing will close it and hide it from all buyers. This action cannot be undone. Are you sure you want to remove this listing?'
                ) : (
                  'This listing will be removed from your view. You can find it again through the marketplace if it becomes active. Are you sure you want to remove this listing?'
                )}
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleRemoveCancel} color="primary" disabled={loading}>
                Cancel
              </Button>
              <Button 
                onClick={() => {
                  removeListing();
                }} 
                style={{ color: '#d32f2f' }} 
                autoFocus
                disabled={loading}
              >
                {loading ? 'Removing...' : "Yes, I'm sure"}
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Mutation>
    </React.Fragment>
  );
}

PartialSaleListing.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      }),
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
  company: PropTypes.shape({
    feature_flags: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  user: PropTypes.shape({
    id: PropTypes.number,
  }),
  showMetricsColumns: PropTypes.bool,
};

export default PartialSaleListing;